<template>
  <v-container class="pa-0 max-width-md">
    <v-card
      flat
      tile
      class="pa-3 pt-2"
    >
      <v-toolbar
        flat
      >
        <v-btn
          icon
          to="/training/Attendance"
        >
          <v-icon>{{ mdiArrowLeft }}</v-icon>
        </v-btn>
        <v-toolbar-title v-if="classInfo">
          {{ chPtObjData('nameZh', classInfo) }}
        </v-toolbar-title>
      </v-toolbar>
      <h3 class="mt-4 text-body-2 grey--text">
        {{ $t('Training.Checkin.Record') }}
      </h3>
      <div
        v-for="year of attendanceListExtendYears"
        :key="year"
      >
        <h4 class="text-subtitle-1 red--text font-weight-light mt-2 mb-n2">
          {{ year }}
        </h4>
        <v-row
          no-gutters
        >
          <v-col
            v-for="(attendance, i) in attendanceListExtend[year]"
            :key="i"
            cols="12"
            md="6"
            lg="4"
          >
            <v-row>
              <v-col
                cols="6"
                class="pr-0"
              >
                {{ attendance.showDate }}
                <span
                  v-if="attendance.sectionTime"
                  class="blue--text text-body-2"
                >
                  ({{ attendance.sectionTime }})
                </span>
              </v-col>
              <v-col cols="6">
                <div class="d-inline-block mr-1">
                  <s-attendance-icon
                    :status="attendance.status"
                  />
                  <span
                    v-if="attendance.time"
                    class="text-body-2 grey--text"
                  >
                    {{ attendance.time }}
                  </span>
                </div>
                <div class="d-inline-block">
                  <s-attendance-icon
                    :status="attendance.status2"
                  />
                  <span
                    v-if="attendance.time2"
                    class="text-body-2 grey--text"
                  >
                    {{ attendance.time2 }}
                  </span>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>

      <br><br>

      <div class="text-body-2 grey--text text--darken-1">
        <span v-if="classInfo && classInfo.classAddress">
          {{ $t('TrainingClient.Location') }}: {{ classInfo.classAddress.chinese }} {{ classInfo.classAddress.portuguese }}
        </span>

        <br>

        <span class="mr-4">
          <s-attendance-icon status="GENERAL" />
          {{ $t('Training.Checkin.OnTime') }}
        </span>
        <span class="mr-4">
          <s-attendance-icon status="LATE" />
          {{ $t('Training.Checkin.Late') }} / {{ $t('Training.Checkin.leaveEarly') }}
        </span>
        <span class="mr-4">
          <s-attendance-icon status="ABSENT" />
          {{ $t('Training.Checkin.Absent') }}
        </span>
      </div>
    </v-card>
  </v-container>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { mapState } from 'vuex'
import SAttendanceIcon from './components/Attendance/SAttendanceIcon'
import checkinApi from '@/api/training/checkin'
import store from '@/store'
import courseAttendanceStore from '@/store/modules/training/courseAttendance'
import { courseAttendanceModule } from '@/store/moduleName'
import { mdiArrowLeft } from '@mdi/js'

if (!store.state[courseAttendanceModule]) store.registerModule(courseAttendanceModule, courseAttendanceStore)

export default {
  components: {
    SAttendanceIcon
  },
  props: {
    courseId: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {
      mdiArrowLeft: mdiArrowLeft,
      dateFormat: 'MMM D, YYYY HH:mm:ss A',
      dateLocale: 'en',
      attendanceList: []
    }
  },
  // watch: {
  //   attendanceList: function (val) {
  //     console.log(val)
  //   }
  // },
  computed: {
    ...mapState(courseAttendanceModule, [
      'attendanceCourses'
    ]),
    attendanceListExtend: function () {
      let tempAttendanceList = []
      let showDateFormat = 'MMMDo'
      if (this.$i18n.locale !== 'zh') {
        showDateFormat = 'MMM D'
      }
      for (const a of this.attendanceList) {
        const dateInMoment = moment(a.date, this.dateFormat, this.dateLocale)
        tempAttendanceList.push({
          year: dateInMoment.format('YYYY'),
          date: dateInMoment,
          showDate: dateInMoment.locale(this.$i18n.locale).format(showDateFormat),
          unixDate: dateInMoment.unix(),
          sectionTime: a.sectionTime,
          isNeedClassOverSign: a.isNeedClassOverSign,
          time: a.time,
          time2: a.time2,
          status: a.status,
          status2: a.status2
        })
        if (a.sectionTime2) {
          tempAttendanceList.push({
            year: dateInMoment.format('YYYY'),
            date: dateInMoment,
            showDate: dateInMoment.locale(this.$i18n.locale).format(showDateFormat),
            unixDate: dateInMoment.unix(),
            isNeedClassOverSign: a.isNeedClassOverSign,
            time: a.time3,
            time2: a.time4,
            status: a.status3,
            status2: a.status4
          })
        }
      }
      tempAttendanceList = _.orderBy(tempAttendanceList, 'unixDate', 'desc')
      tempAttendanceList = _.groupBy(tempAttendanceList, 'year')
      return tempAttendanceList
    },
    attendanceListExtendYears: function () {
      return _.keys(this.attendanceListExtend).sort((a, b) => b - a)
    },
    classInfo: function () {
      return this.attendanceCourses.find(course => course.classSeqNum === this.courseId)
    }
  },
  created: function () {
    if (!this.attendanceCourses.length) {
      this.$store.dispatch(courseAttendanceModule + '/getClassList')
        .finally(() => {
          this.isLoading = false
        })
    }
    checkinApi.getClasssSignRecord((resp) => {
      // console.log(resp.datas)
      this.attendanceList = resp.datas
    }, this.courseId)
  },
  methods: {
    chPtObjData: function (fieldName, obj) {
      let tFieldName
      if (this.$i18n.locale === 'zh') {
        tFieldName = fieldName.replace('pt', 'zh')
        tFieldName = tFieldName.replace('Pt', 'Zh')
        if (!obj[tFieldName]) {
          tFieldName = fieldName.replace('zh', 'pt')
          tFieldName = tFieldName.replace('Zh', 'Pt')
        }
      } else {
        tFieldName = fieldName.replace('zh', 'pt')
        tFieldName = tFieldName.replace('Zh', 'Pt')
        if (!obj[tFieldName]) {
          tFieldName = fieldName.replace('pt', 'zh')
          tFieldName = tFieldName.replace('Pt', 'Zh')
        }
      }

      if (obj[tFieldName]) {
        return obj[tFieldName]
      } else {
        return ''
      }
    },
    moment: moment
  }
}
</script>
